import React from "react";
import { useAppContext } from "../../AppProvider";
import { useTrackingContext } from "./providers/Tracking";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "../../utilities/fontawesomeIcons";
import { Modal, ModalBody } from "reactstrap";
import Event from "../Tracking/Event";
import ButtonUtility from "../../Components/Buttons/Utility";

const Tracking: React.FC = () => {
  const { dictionary } = useAppContext();
  const { isOpen, data, loader, getData, shipment, retracking } =
    useTrackingContext();

  return (
    <React.Fragment>
      {/* <CardHeader> */}
      <div
        className="cursor-pointer"
        onClick={() => {
          if (shipment.id) {
            getData(!isOpen);
          }
        }}
      >
        {shipment.id && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center cursor-pointer"
            style={{
              zIndex: 10,
              borderRadius: "inherit",
            }}
          ></div>
        )}
      </div>
      {/* </CardHeader> */}

      <Modal isOpen={isOpen}>
        <ModalBody>
          {loader ? (
            <div className="text-center mt-2 ">
              <FontAwesomeIcon icon={faLoader} spin size="2x" />
            </div>
          ) : (
            <>
              {shipment.forceTrackingEnabled && (
                <div className="row">
                  <div className="col text-end">
                    <ButtonUtility onClick={retracking}>
                      {dictionary.words.retracking}
                    </ButtonUtility>
                  </div>
                </div>
              )}
              {data.map((elem, i) => {
                return (
                  <Event
                    key={i}
                    data={elem}
                    formatDate={"DD/MM/YYYY HH:mm"}
                    shipment={shipment}
                    isLastEvent={i === 0}
                  />
                );
              })}
              <div className="d-flex mt-3">
                <ButtonUtility
                  className="w-100"
                  onClick={() => getData(!isOpen)}
                  disabled={loader}
                >
                  {dictionary.actions.close}
                </ButtonUtility>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default Tracking;
